export default "__VITE_ASSET__D1R0mUSp__"